import type { SubscriptionStatus } from "@/react/types/CurrentCommunity";

export const isSubscriptionIncompleteExpired = (
  status?: SubscriptionStatus,
): boolean => status === "incomplete_expired";

export const isSubscriptionIncomplete = (
  status?: SubscriptionStatus,
): boolean => status === "incomplete";
